//options: https://glidejs.com/docs/options/
import Glide from '@glidejs/glide'
import A11yDialog from 'a11y-dialog';
import breakpoints from '../breakpoints';

/**
 * Create a carousel for vehicle page image carousel
 */
export const init = () => {
  const carouselElement = document.querySelector('.vehicle-image-carousel .glide');
  const carouselElementThumbs = document.querySelector('.vehicle-thumb-image-carousel .glideThumbs');

  const glide = new Glide(carouselElement, {
    type: 'carousel',
    focusAt: 'center',
    startAt: 0,
    perView: 1,
    peek: 0,
    gap: 1,
    keyboard: false, //keyboard arrows controlled carousel even if it was not selected
    breakpoints: {
      [breakpoints.xs]: {
        perView: 1,
        gap: 1,
      }
    }
  });

  /**
   * update current slide number
   */
  glide.on('move.after', function() {
    const text = document.querySelector('.js-vehicle-image-carousel__running-number');
    if(text && typeof glide.index === 'number') text.innerHTML = glide.index + 1;
  });

  glide.mount();

  const glideThumbs = new Glide(carouselElementThumbs, {
    type: 'carousel',
    focusAt: 'center',
    startAt: 0,
    perView: 5,
    peek: 2,
    gap: 16,
    keyboard: false, //keyboard arrows controlled carousel even if it was not selected
    breakpoints: {
      [breakpoints.sm]: {
        perView: 3,
        gap: 10,
      },
      [breakpoints.xl]: {
        perView: 3,
        gap: 10,
      }
    }
  });

  // iOS Safari bugfix (swipe desync)
  let windowSize = window.innerWidth;
  if (windowSize > 768) {
    glideThumbs.mount();
  }
  function resizeFunction() {
    let windowSize = window.innerWidth;
    if (windowSize < 768) {
      carouselElementThumbs.classList.contains('glide--carousel') ? glideThumbs.disable() : [];
    } else {
      carouselElementThumbs.classList.contains('glide--carousel') ? glideThumbs.enable() : glideThumbs.mount();
    }
  }
  window.addEventListener('resize', resizeFunction);

  //activate that slide by clicking on it
  carouselElement.querySelectorAll('.glide__slide').forEach((slide) => {
    slide.addEventListener('click', () => {
      const sliderIndex = slide.dataset.index;
      if (sliderIndex && sliderIndex >= 0) glide.go('='+sliderIndex);
    });
  });

  //activate that slide by clicking on it
  carouselElementThumbs.querySelectorAll('.glide__slide').forEach((slide) => {
    slide.addEventListener('click', () => {
      const sliderIndex = slide.dataset.index;
      if (sliderIndex && sliderIndex >= 0) glideThumbs.go('='+sliderIndex);
    });
  });

  glideThumbs.on('move.after', function() {
    glide.go('='+glideThumbs.index);
  });

  /**
   * Create vehicle image modal
   */
  const imageModalElement = document.getElementById('vehicle-image-modal');
  if(imageModalElement) {
    const dialog = new A11yDialog(imageModalElement);

    const modalOpenButton = document.querySelector('button[data-a11y-dialog-show]');
    modalOpenButton.addEventListener('click', () => {
      // history.pushState({modalOpen: false}, null, '');
    });

    const modalCloseButtons = document.querySelectorAll('*[data-a11y-dialog-hide]');
    modalCloseButtons.forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        // history.pushState({modalOpen: true}, null, '');
      });
    });

    //hide/show modal on mobile on back press.
    window.onpopstate = (e) => {
      if(typeof e.state?.modalOpen === 'undefined') {
        if(dialog.shown === true) dialog.hide();
        return false;
      }

      if(e.state.modalOpen === true && dialog.shown === true) {
        dialog.hide();
      } else if(e.state.modalOpen === false && dialog.shown === false) {
        dialog.show();
      }
    }
  }

  /**
   * Create vehicle 360 image modal
   */
  const imageModalElement360 = document.getElementById('vehicle-360-image-modal');
  if(imageModalElement360) {
    const dialog = new A11yDialog(imageModalElement360);

    const modalOpenButton360 = document.querySelector('button[data-a11y-dialog-show]');
    modalOpenButton360.addEventListener('click', () => {
      // history.pushState({modalOpen: false}, null, '');
    });

    const modalCloseButtons360 = document.querySelectorAll('*[data-a11y-dialog-hide]');
    modalCloseButtons360.forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        // history.pushState({modalOpen: true}, null, '');
      });
    });

    //hide/show modal on mobile on back press.
    window.onpopstate = (e) => {
      if(typeof e.state?.modalOpen === 'undefined') {
        if(dialog.shown === true) dialog.hide();
        return false;
      }

      if(e.state.modalOpen === true && dialog.shown === true) {
        dialog.hide();
      } else if(e.state.modalOpen === false && dialog.shown === false) {
        dialog.show();
      }
    }
  }

  /**
   * Create vehicle contact form modal
   */
  const imageModalElementContactForm = document.getElementById('vehicle-contact-form');
  if(imageModalElementContactForm) {
    const dialog = new A11yDialog(imageModalElementContactForm);

    const modalOpenButtonContactForm = document.querySelector('button[data-a11y-dialog-show]');
    modalOpenButtonContactForm.addEventListener('click', () => {
      // history.pushState({modalOpen: false}, null, '');
    });

    const modalCloseButtonsContactForm = document.querySelectorAll('*[data-a11y-dialog-hide]');
    modalCloseButtonsContactForm.forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        // history.pushState({modalOpen: true}, null, '');
      });
    });

    //hide/show modal on mobile on back press.
    window.onpopstate = (e) => {
      if(typeof e.state?.modalOpen === 'undefined') {
        if(dialog.shown === true) dialog.hide();
        return false;
      }

      if(e.state.modalOpen === true && dialog.shown === true) {
        dialog.hide();
      } else if(e.state.modalOpen === false && dialog.shown === false) {
        dialog.show();
      }
    }

    if (window.location.hash === `#${imageModalElementContactForm?.querySelector('.stage-form')?.getAttribute('id')}`) {
      setTimeout(() => {
        dialog.show();
      }, 500);
    }
  }

  /**
   * Create vehicle calculator modal
   */
  const calculatorModalElement = document.getElementById('rahoituslaskuri');
  if(calculatorModalElement) {
    const dialog = new A11yDialog(calculatorModalElement);

    const modalOpenButtonContactForm = document.querySelector('button[data-a11y-dialog-show]');
    modalOpenButtonContactForm.addEventListener('click', () => {
      // history.pushState({modalOpen: false}, null, '');
    });

    const modalCloseButtonsContactForm = document.querySelectorAll('*[data-a11y-dialog-hide]');
    modalCloseButtonsContactForm.forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        // history.pushState({modalOpen: true}, null, '');
      });
    });

    //hide/show modal on mobile on back press.
    window.onpopstate = (e) => {
      if(typeof e.state?.modalOpen === 'undefined') {
        if(dialog.shown === true) dialog.hide();
        return false;
      }

      if(e.state.modalOpen === true && dialog.shown === true) {
        dialog.hide();
      } else if(e.state.modalOpen === false && dialog.shown === false) {
        dialog.show();
      }
    }
  }

}
